import React, { Fragment } from 'react';
import StatsMenu from '../../../../components/StatsMenu';
import Visits from './visits';
import Countries from './countries';
import Referrers from './referrers';
import Users from './users';

class ArtistAnalytics extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      active: 'visits',
    };
  }

  onChangeStatsType = (type) => {
    this.setState({ active: type });
  };

  render() {
    const { active } = this.state;
    return (
      <Fragment>
        <h1 className="heading">Analíticas</h1>

        <div className="analytics__main">
          <div className="analytics__sidebar">
            <StatsMenu onChange={this.onChangeStatsType} active={active} />
          </div>
          <div className="analytics__content">
            {active === 'visits' && (
              <Visits />
            )}
            {active === 'countries' && (
              <Countries />
            )}
            {active === 'users' && (
              <Users />
            )}
            {active === 'referrers' && (
              <Referrers />
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ArtistAnalytics;



// WEBPACK FOOTER //
// ./src/containers/Artist/Analytics/Artist/index.js